import { schemaTranslations } from '@scalar/blocks/schema'
import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const es = {
  common: {
    streamItem: 'Elemento del flujo',
    description: 'Descripción',
    httpMethod: 'Método HTTP',
    path: 'Ruta',
    copyDefault: 'Copiar valor por defecto',
    copyExample: 'Copiar valor de ejemplo',
  },
  search: {
    label: 'Buscar',
    inputLabel: 'Introduce tu consulta de búsqueda',
    open: 'Abrir búsqueda',
    placeholder: 'Buscar...',
    clear: 'Borrar búsqueda',
    noResults: 'No se encontraron resultados',
    keyboardShortcut: 'Atajo de teclado:',
    command: 'Comando',
    control: 'Control',
    results: 'Resultados de búsqueda de la referencia',
    navigate: 'Navegar',
    select: 'Seleccionar',
    instructions: 'Pulsa flecha arriba o abajo para navegar, Enter para seleccionar y escribe para filtrar resultados',
    entryHeading: 'Encabezado',
    entryOperation: 'Operación',
    entryTag: 'Etiqueta',
    entryTagGroup: 'Grupo de etiquetas',
    entryChannel: 'Canal',
    entryMessage: 'Mensaje',
    entryWebhook: 'Webhook',
  },
  navigation: {
    introduction: 'Introducción',
    closeGroup: 'Cerrar grupo',
    closeMenu: 'Cerrar menú',
    openGroup: 'Abrir grupo',
    openMenu: 'Abrir menú',
    operations: 'Operaciones',
    endpoints: 'Endpoints de {name}',
    showAllEndpoints: 'Mostrar todos los endpoints de {name}',
    sidebarFor: 'Barra lateral de {name}',
    mainContent: 'Documentación de la API de {name}',
    collapsed: 'Contraído',
    webhooks: 'Webhooks',
    channels: 'Canales',
  },
  server: {
    label: 'Servidor',
    select: 'Seleccionar un servidor',
  },
  info: {
    termsOfService: 'Términos del servicio',
  },
  asyncapi: {
    applicationIdentifier: 'Identificador de la aplicación',
    servers: 'Servidores',
    protocols: 'Protocolos',
  },
  clientLibraries: {
    heading: 'Bibliotecas cliente',
    more: 'Más',
    selectAll: 'Seleccionar entre todos los clientes',
    searchLabel: 'Buscar clientes',
    changeClient: 'Cambiar el lenguaje del ejemplo de código',
  },
  operation: {
    codeSampleUnavailable: 'No hay ninguna muestra de código disponible para este ejemplo.',
    codeSample: 'Ejemplo de código',
    body: 'Cuerpo',
    cookies: 'Cookies',
    headers: 'Encabezados',
    pathParameters: 'Parámetros de ruta',
    queryParameters: 'Parámetros de consulta',
    requestBody: 'Cuerpo de la solicitud',
    responses: 'Respuestas',
    testRequest: 'Probar solicitud',
    webhook: 'Webhook',
    audience: 'Audiencia',
    selectedContentType: 'Tipo de contenido seleccionado',
    callbacks: 'Callbacks',
  },
  response: {
    xmlGenerationLimit:
      'El ejemplo XML supera el límite de generación. Proporcione un ejemplo XML serializado para mostrar el contenido completo.',
    xmlGenerationFailed: 'No se puede generar un ejemplo XML: {message}',
    exampleResponses: 'Ejemplos de respuesta',
    noBody: 'Sin cuerpo',
    showSchema: 'Mostrar esquema',
    status: 'Estado',
  },
  schema: schemaTranslations['es'].schema,
  download: {
    openapi: 'Descargar documento OpenAPI',
    asyncapi: 'Descargar documento AsyncAPI',
    asFormat: '{label} en {format}',
  },
  models: {
    label: 'Modelos',
  },
  actions: {
    copyAsMarkdown: 'Copiar como Markdown',
    copied: 'Copiado',
    copyMarkdownFailed: 'No se pudo copiar Markdown',

    copyLink: 'Copiar enlace',
    copyLinkTo: 'Copiar enlace a {name}',
    copyToClipboard: 'Copiar enlace al portapapeles',
    copyEndpointUrl: 'Copiar URL del endpoint',
    showMore: 'Mostrar más',
  },
  agent: {
    askAi: 'Preguntar a IA',
    askAiAgent: 'Preguntar al agente de IA',
    close: 'Cerrar cliente',
  },
  mcp: {
    generate: 'Generar MCP',
    connect: 'Conectar MCP',
  },
  sdk: {
    generate: 'Generar SDK',
  },
  developerTools: {
    title: 'Herramientas de desarrollo',
    configure: 'Configurar',
    share: 'Compartir',
    deploy: 'Desplegar',
    scalarConfiguration: 'Configuración de Scalar',
    theme: 'Tema',
    layout: 'Diseño',
    layoutOptions: 'Opciones de diseño',
    intro:
      'Las herramientas de desarrollo te permiten personalizar la apariencia y el comportamiento de tu documentación. También puedes compartir tu documentación con Scalar Registry.',
    disableToolbarBefore: 'Para desactivar la barra de herramientas, configura',
    disableToolbarAfter: 'en tu configuración.',
    localhostOnly: 'Las herramientas de desarrollo solo aparecerán al ejecutarse en localhost.',
    layoutModern: 'Moderno',
    layoutClassic: 'Clásico',
    showSidebar: 'Mostrar barra lateral',
    defaultOpenFirstTag: 'Abrir la primera etiqueta por defecto',
    defaultOpenAllTags: 'Abrir todas las etiquetas por defecto',
    expandAll: 'Expandir todo {label}',
    expandAllResponses: 'Expandir todas las respuestas',
    hideClientButton: 'Ocultar botón del cliente',
    hideDarkModeToggle: 'Ocultar selector de modo oscuro',
    hideModels: 'Ocultar {label}',
    hideSearch: 'Ocultar búsqueda',
    showOperationId: 'Mostrar ID de operación',
    hideTestRequestButton: 'Ocultar botón de solicitud de prueba',
    scalarDocs: 'Scalar Docs',
    deployDescription:
      'Despliega tu documentación en Scalar, la plataforma moderna de documentación para tu API y mucho más.',
    shareTitle: 'Comparte tu API Reference',
    shareDescription:
      'Sube tu documento OpenAPI para compartir tu API Reference con otras personas. Tan fácil como pulsar un botón.',
    uploadDocument: 'Subir documento',
    temporaryLinkExpiration: 'Tu documento se eliminará automáticamente después de 7 días.',
    deployOnScalar: 'Desplegar en Scalar',
    deployFree: 'Despliega tu documentación gratis.',
    additionalFeaturesMightRequire: 'Las funciones adicionales pueden requerir',
    generate: 'Generar',
    passwordProtection: 'Protección con contraseña',
    customDomains: 'Dominios personalizados',
    freeFormContent: 'Contenido libre',
    cdnInfrastructure: 'Infraestructura CDN',
    pullFromGitHub: 'Importar desde GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Linting de Spectral',
    jsonSchemaHosting: 'Alojamiento de JSON Schema',
    askAi: 'Preguntar a IA',
    mcpServers: 'Servidores MCP',
    unableToExportDocument: 'No se pudo exportar el documento activo',
    unknownError: 'Se produjo un error desconocido',
  },
  exploreScalar: {
    cta: 'Genera SDKs y MCP',
    headline: 'Genera SDKs, MCPs y docs para tu API al instante',
    title: 'Todo lo que tu API necesita, a partir de un solo documento OpenAPI',
    generateTitle: 'SDKs y servidores MCP',
    generateDescription:
      'Bibliotecas cliente tipadas y un servidor MCP, generados a partir de este documento y siempre sincronizados.',
    platformTitle: 'Docs, portales para desarrolladores y registro',
    platformDescription:
      'Publica esta referencia con guías, aloja tus APIs en un registro y pruébalas en el cliente de API.',
    signUp: 'Pruébalo gratis',
    bookDemo: 'Reserva una demo con Marc, nuestro CEO',
    getDemo: 'o consigue una demo con Marc',
    messageMarc: 'Escribe a Marc en X',
    dmMarc: '¡o simplemente escríbeme por X!',
    close: 'Cerrar',
    opensInNewTab: 'Se abre en una pestaña nueva',
    popupBlocked: 'Tu navegador bloqueó la pestaña nueva. Haz clic de nuevo en el botón para abrirla.',
    back: 'Atrás',
    openBookingPage: 'Abrir la página de reserva',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      'Bienvenido a Scalar API References + Swagger Editor, una herramienta gratuita y de código abierto que toma tu archivo Swagger/OAS y genera API References elegantes.',
    showExample: 'Mostrar ejemplo',
    uploadFile: 'Subir archivo',
    integrations: 'INTEGRACIONES',
    theming: 'TEMAS',
    features: 'Funciones',
    customize: 'Personalizar',
    customizeDescription: 'Usa tu tipografía y paletas de colores, o nuestros temas.',
    testing: 'Pruebas',
    testingDescription: 'Un REST API Client profundamente integrado (también gratuito y de código abierto)',
    search: 'Búsqueda',
    searchDescription: 'Búsqueda completamente integrada (con fuse.js)',
    hosting: 'Hosting',
    hostingDescription: 'Hosting gratuito en un subdominio de https://apidocumentation.com',
    openApiSwagger: 'OpenAPI y Swagger',
    openApiSwaggerDescription: 'Compatibilidad con OpenAPI 3.1, OpenAPI 3.0 y Swagger 2.0',
    codeSamples: 'Ejemplos de código',
    codeSamplesDescription: 'Ejemplos de código para mostrar tu API en los lenguajes más populares',
  },
  footer: {
    poweredByScalar: 'Desarrollado por Scalar',
  },
  authentication: {
    detailsRequired: 'Autenticación obligatoria',
    detailsOptional: 'Autenticación opcional',
    apiKey: 'Clave API',
    mutualTLS: 'TLS mutuo',
    apiKeyCookie: 'Envía la clave API en la cookie «{name}».',
    apiKeyHeader: 'Envía la clave API en la cabecera «{name}».',
    apiKeyQuery: 'Envía la clave API en el parámetro de consulta «{name}».',
    title: 'Autenticación',
    accepts: 'Acepta',
    allOf: 'todo lo siguiente:',
    authentication: 'autenticación',
    optional: 'Autenticación opcional',
    oneOf: 'uno de:',
    required: 'Autenticación requerida',
    requires: 'Requiere',
    scopes: 'Ámbitos de OAuth',
  },
} satisfies ApiReferenceTranslations
